import {
  baseWorkflowSteps,
  getWorkflowSteps,
  WorkflowEditPageStep,
} from "@/pages/workflows/edit/pages/workflow-edit-pages.tsx";
import { ApiWorkflow, ApiWorkflowVersion } from "@/types/workflows/workflow.types.ts";
import { DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface WorkflowTitleSlotProps {
  step: WorkflowEditPageStep;
  workflow?: ApiWorkflow;
  workflowVersion?: ApiWorkflowVersion;
}

export const WorkflowTitleSlot = ({ step, workflow, workflowVersion }: WorkflowTitleSlotProps) => {
  const { t } = useTranslation();
  const steps = workflow
    ? getWorkflowSteps(workflow.trigger_type, workflowVersion?.trigger_schedule_rule?.entity_type)
    : baseWorkflowSteps;
  const stepIndex = steps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("workflow:workflow")}</Text>
      {stepIndex > 0 && workflow && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          <Text className={"font-semibold"}>{workflow.title}</Text>
        </Stack>
      )}
      <Text>
        {t("core:step_of", {
          currentStep: stepIndex + 1,
          countSteps: steps.length,
        })}
      </Text>
    </DotSeparator>
  );
};
